import { render, staticRenderFns } from "./EpsilonIcon.vue?vue&type=template&id=cfb2be8a"
import script from "./EpsilonIcon.vue?vue&type=script&lang=js"
export * from "./EpsilonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports